import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withTranslator } from '@front-activerse/common-components';
import { InputSelectControlled } from '@front-activerse/common-components';

class HistoryChartPeriodSelect extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    value: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
  };

  periods = new Map([
    [7, this.props.t('history.select.week', { count: 1 })],
    [14, this.props.t('history.select.week', { count: 2 })],
    [31, this.props.t('history.select.month', { count: 1 })],
    [92, this.props.t('history.select.month', { count: 3 })],
    [183, this.props.t('history.select.month', { count: 6 })],
  ]);

  render() {
    return (
      <InputSelectControlled
        handleChange={this.props.onChange}
        name="history-length"
        value={this.props.value}
        className="mb-xl"
        small
      >
        {Array.from(this.periods.entries()).map(([value, label]) => (
          <option key={value} value={value}>
            {label}
          </option>
        ))}
      </InputSelectControlled>
    );
  }
}

export { HistoryChartPeriodSelect };
export default withTranslator(HistoryChartPeriodSelect);
